// exports

export function isValidDate(date: string) {
	const parsedDate = Date.parse(date.replace(/\s/g, 'T'));
	return !isNaN(parsedDate);
}
